<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  transition: 0.3;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #222;
  height: 100vh;
  font-size: 0.833vw;
  transition: 0.3s;
}
.el-submenu.is-active .el-submenu__title{
  background: #2174E7;
  color: #fff;
}
.el-menu-item.is-active{
  background: #2174E7;
  color: #fff;
}
.el-submenu.is-opened .el-submenu__title{
  background: #fff;
  color: #222;

}
.el-submenu__title i{
  color: inherit;
}
.el-tabs__item.is-active{
  color: #2174E7;
}
.el-tabs__active-bar{
  background-color:#2174E7;
}
.el-tabs__item{
  font-size: 0.938vw;
  font-weight: 600;
}
/* .el-menu{
  background-color: rgba(255, 255, 255,0);
  font-weight: 600;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 0.208vw solid #294797;
  color: #294797;
  background-color: rgba(255, 255, 255,0);
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-submenu .el-submenu__title:hover{
  color: #294797;
  background-color: rgba(255, 255, 255,0);
}
.el-menu--horizontal .el-menu--popup .el-menu-item:not(.is-disabled):hover{
  background-color: #fff;
}
.el-menu.el-menu--horizontal{
  border: none;
} */
/* .el-menu--horizontal>.el-menu-item,.el-menu--horizontal>.el-submenu .el-submenu__title{
  color: #fff;
  height: 4.167vw;
  line-height: 4.167vw
} */
/* .el-submenu__title i{
  color: #fff;
} */
.el-menu{
  border: none;
}
/* .el-menu--popup .el-submenu__title i{
  color: #222;
}
.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
.el-submenu__title:focus{
  background-color: rgba(255, 255, 255,0);
  color: #294797;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  border-bottom: 0.208vw solid #294797;
  color: #294797;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title i{
  color: #294797;
}
.el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title{
  color: #294797;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active{
  color: #294797;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue